import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import CardTitle from "@saleor/components/CardTitle";
import { FormSpacer } from "@saleor/components/FormSpacer";
import SingleAutocompleteSelectField, {
  SingleAutocompleteChoiceType
} from "@saleor/components/SingleAutocompleteSelectField";
import { ChangeEvent } from "@saleor/hooks/useForm";
import { FetchMoreProps } from "@saleor/types";
import React from "react";
import { useIntl } from "react-intl";

const useStyles = makeStyles(
  theme => ({
    card: {
      overflow: "visible"
    },
    cardSubtitle: {
      fontSize: "1rem",
      marginBottom: theme.spacing(0.5)
    },
    label: {
      marginBottom: theme.spacing(0.5)
    }
  }),
  { name: "SaleCornermarks" }
);

interface SaleCornermarksProps {
  cornermarks?: SingleAutocompleteChoiceType[];
  cornermarkInputDisplayValue: string;
  data: {
    cornerMark: string;
  };
  disabled: boolean;
  fetchCornermarks: (query: string) => void;
  fetchMoreCornermarks: FetchMoreProps;
  onCornermarkChange: (event: ChangeEvent) => void;
}

const SaleCornermarks: React.FC<SaleCornermarksProps> = props => {
  const {
    cornermarks,
    cornermarkInputDisplayValue,
    data,
    disabled,
    fetchCornermarks,
    fetchMoreCornermarks,
    onCornermarkChange
  } = props;

  const classes = useStyles(props);
  const intl = useIntl();
  return (
    <Card className={classes.card}>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Cornermark",
          description: "section header"
        })}
      />
      <CardContent>
        <SingleAutocompleteSelectField
          displayValue={cornermarks ? cornermarkInputDisplayValue : ""}
          disabled={disabled}
          label={intl.formatMessage({
            defaultMessage: "Cornermark"
          })}
          choices={disabled ? [] : cornermarks}
          thumbnail={true}
          name="cornerMark"
          value={
            disabled
              ? null
              : typeof data?.cornerMark == "object"
              ? data?.cornerMark
              : ""
            // : typeof data?.cornerMark == "string"
            //   ? data?.cornerMark?.replace(/[\'|\-]/g, "")
            //   : data?.cornerMark
          }
          onChange={onCornermarkChange}
          fetchChoices={fetchCornermarks}
          emptyOption={true}
          {...fetchMoreCornermarks}
        />

        <FormSpacer />
      </CardContent>
    </Card>
  );
};
SaleCornermarks.displayName = "SaleCornermarks";
export default SaleCornermarks;
